// @ts-nocheck
import { Box, Button, Paper, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Lottie from 'react-lottie'
import { connect } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'

import ExcelLogo from '../../../../assets/images/learnstage-logo.png'
import successImg from '../../../../assets/lotties/sumbit_success.json'
import { ROUTES } from '../../../../helpers/constants'
import { getSchoolUrl } from '../../../../helpers/utils'
function PaymentSuccessGuestCheckout({ school, thankYouMessage }) {
  const { t } = useTranslation()
  const params = useParams()
  const history = useHistory()

  const redirectTimerRef = useRef(null)
  const [stopped, setStopped] = useState(false)

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: successImg,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  useEffect(() => {
    setTimeout(() => {
      setStopped(true)
    }, 3400)
  }, [])

  useEffect(() => {
    return () => {
      clearInterval(redirectTimerRef.current)
    }
  }, [])

  return (
    <>
      <Box
        pb={2}
        px={3}
        display="flex"
        alignItems="flex-start"
        justifyContent="flex-start"
        flexDirection="column"
      >
        <Box
          width="100%"
          flexGrow={0}
          display="flex"
          alignItems="center"
          justifyContent={{ xs: 'center', md: 'space-between' }}
          flexDirection="row"
          px={0}
          py={2}
          className="allProgmResvi-between"
        >
          <Box className="brand-logo">
            <img
              src={school.sch_logo || ExcelLogo}
              alt="Logo"
              onError={(e) => {
                e.target.onerror = null
                e.target.src = ExcelLogo
              }}
            />
          </Box>
        </Box>
        <Typography component="h4" align="left" variant="h5" color="textPrimary" tabIndex={0}>
          <Box component="span" fontWeight="700">
            {t('schooStoreGuestCheckout')}
          </Box>
        </Typography>
      </Box>
      <Box px={3}>
        <Paper rounded="true" elevation={1} className="paper-round">
          <Box p={{ xs: 0, sm: 3 }}>
            <Box
              width="100%"
              minHeight={{ xs: '100px', md: '450px', lg: '600px' }}
              p={2}
              display="flex"
              alignItems="flex-start"
              justifyContent="flex-start"
              flexDirection="column"
            >
              <Box
                px={{ xs: 2, sm: 3 }}
                pt={2}
                width={{ xs: '100%', md: '70%', xl: '50%' }}
                mx="auto"
                mb={2}
              >
                <Box display="flex" justifyContent="center" alignItems="center">
                  <Lottie options={defaultOptions} height={150} width={150} isPaused={stopped} />
                </Box>

                <>
                  <Box mt={1} mb={3} px={3}>
                    <Typography
                      component="div"
                      align="center"
                      variant="h4"
                      color="textPrimary"
                      gutterBottom
                      tabIndex={0}
                    >
                      <Box width="100%" component="span" fontWeight="700" fontSize="32px">
                        {t('thankYouSuccessfully')}
                      </Box>
                    </Typography>
                    <Typography
                      component="div"
                      align="center"
                      variant="body2"
                      color="textSecondary"
                      tabIndex={0}
                    >
                      <Box
                        display="flex"
                        mt={3}
                        width="100%"
                        component="span"
                        fontWeight="500"
                        dangerouslySetInnerHTML={{
                          __html: thankYouMessage,
                        }}
                        className="guess-checkout-thank-msg"
                      ></Box>
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="row"
                    flexWrap="wrap"
                  >
                    <Box mt={2} display="flex" justifyContent="center" alignItems="center">
                      <Button
                        className="custom-default-button text-transform-none"
                        size="large"
                        variant="contained"
                        disableElevation
                        color="primary"
                        onClick={() => {
                          history.push(getSchoolUrl({ ...params, to: `${ROUTES.LOGIN}` }))
                        }}
                        replaceHistory={true}
                      >
                        {t('goToLogin')}
                      </Button>
                    </Box>
                  </Box>
                </>
              </Box>
            </Box>
          </Box>
        </Paper>
      </Box>
    </>
  )
}

PaymentSuccessGuestCheckout.propTypes = {
  school: PropTypes.object,
  thankYouMessage: PropTypes.string,
}

PaymentSuccessGuestCheckout.defaultProps = {
  school: {},
  thankYouMessage: '',
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(PaymentSuccessGuestCheckout)
